module.exports = __webpack_public_path__ + "static/media/findPair_icon--active.09a91321.svg";